import GlobalCommandMenu from '@/components/command-modal/globalCommandModal'
import MiniSidebar from '@/components/mini-sidebar'
import { Input } from '@/components/ui/input'
import Header from '@/layouts/layout/header'
import { Outlet, useRouterState } from '@tanstack/react-router'
import { createContext, useContext, useMemo, useState } from 'react'
import WorkspaceSidebar from './workspace-sidebar'

//only avialable when VITE_ENV is "DEV" and ctrl + shift + Q is pressed
const Repl = () => {
  const [q, setQ] = useState<string>("")
  const [history, setHistory] = useState<string[]>([])
  const [histIdx, setHistIdx] = useState<number>()
  return <form onSubmit={(e) => {
    e.preventDefault()
    console.log(q)
    //@ts-ignore
    setHistory([q, ...history])
    setQ("")
  }}>
    <Input value={q}
      onKeyDown={(e) => {
        if (e.key === "ArrowUp") {
          if (histIdx === undefined) {
            setHistIdx(0)
            setQ(history[0])
          }
          else if (histIdx < history.length - 1) {
            setHistIdx(histIdx + 1)
            setQ(history[histIdx + 1])
          }
        }
        if (e.key === "ArrowDown") {

          if (histIdx && histIdx > 0) {
            setHistIdx(histIdx - 1)
            setQ(history[histIdx - 1])
          }
          else if (histIdx === 0) {
            setHistIdx(undefined)
            setQ("")
          }
        }
      }}

      onChange={(e) => {
        setQ(e.target.value)
      }}></Input>
  </form>
}

const PrintContext = createContext<PrintContext | null>(null)

export function usePrint() {
  const ctx = useContext(PrintContext)
  if (!ctx) {
    throw new Error("usePrint must be used within a PrintProvider")
  }
  return ctx
}

type PrintContext = {
  printMode: boolean,
  setPrintMode: (v: boolean) => void
}

export default function Component() {
    const router = useRouterState();
    const [showRepl] = useState(false)
    const [printMode, setPrintMode] = useState(false)
      const printContextValue = useMemo(
        () => ({
          printMode,
          setPrintMode
        })
        , [printMode, setPrintMode])

  const hideHeader = router.location.pathname.startsWith("/settings");

    return (
      <PrintContext.Provider value={printContextValue}>
        <main className={`${printMode ? "" : "max-w-screen h-screen max-h-screen overflow-hidden"}`}>
            <div className={`flex flex-col w-full h-full`}>
                {
                    showRepl && import.meta.env.VITE_ENV === "DEV" && <Repl />
                }
                {(printMode || hideHeader) ? null : <Header />}
                <div className={`flex-1 flex ${printMode ? "" : "overflow-hidden"}`}>
                    <MiniSidebar />
                    <WorkspaceSidebar />
                    <div className="flex-1 h-full overflow-auto px-4">
                        <GlobalCommandMenu />
                        <Outlet />
                    </div>
                </div>
            </div>
        </main>
      </PrintContext.Provider>
    );
}